module.exports = __webpack_public_path__ + "static/media/icon-calendar.582dac05.svg";